import { isObject } from 'lodash';

function getSocialModel(encodedPostUrl, text, subject) {
  let emailText;
  let twitterText;
  let linkedinText;

  if (isObject(text)) {
    twitterText = text.twitter;
    linkedinText = text.linkedin;
    emailText = text.email;
  } else {
    emailText = text;
    twitterText = text;
    linkedinText = text;
  }

  return [
    {
      property: 'facebook',
      url: `https://www.facebook.com/sharer.php?u=${encodedPostUrl}&app_id=178479832213933&display=popup`,
      popup: true,
      socialShare: {
        platform: 'Facebook',
        action: 'share'
      }
    },
    {
      property: 'twitter',
      url: `https://twitter.com/share?url=${encodedPostUrl}&text=${twitterText}`,
      popup: true,
      socialShare: {
        platform: 'Twitter',
        action: 'tweet'
      }
    },
    {
      property: 'linkedin',
      url: `https://www.linkedin.com/shareArticle?mini=true&url=${encodedPostUrl}&media=${linkedinText}`,
      popup: true,
      socialShare: {
        platform: 'Linkedin',
        action: 'share'
      }
    },
    {
      property: 'email',
      url: `mailto:?body=${emailText} ${encodedPostUrl}&subject=${subject ||
        encodedPostUrl}`,
      icon: 'share-email',
      popup: false,
      socialShare: {
        platform: 'Email',
        action: 'email'
      }
    }
  ];
}

export default getSocialModel;
